import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=e196c8f0&scoped=true&"
import script from "./userAdd.vue?vue&type=script&lang=ts&"
export * from "./userAdd.vue?vue&type=script&lang=ts&"
import style0 from "./userAdd.vue?vue&type=style&index=0&id=e196c8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e196c8f0",
  null
  
)

export default component.exports